import {
	WeaTools
} from 'ecCom'

export const getAuth = (params) => {
	return WeaTools.callApi('/api/hrm/applyinfo/getHasRight', 'GET', params);
}

export const getButtonsMenu = (params) => {
	return WeaTools.callApi('/api/hrm/usedemandrp/getRightMenu', 'GET', params);
}

export const getRadioGroupDatas = (params) => {
	return WeaTools.callApi('/api/hrm/usedemandrp/getSearchCondition', 'GET', params);
}

export const getBarChartsDatas = (params) => {
	return WeaTools.callApi('/api/hrm/usedemandrp/getRpResult', 'GET', params);
}

export const getTabsDatas = (params) => {
	return WeaTools.callApi('/api/hrm/usedemandrp/getRpResult2', 'GET', params);
}

export const getSearchCondition = (params) => {
	return WeaTools.callApi('/api/hrm/usedemandrp/getDetailSearchCondition', 'GET', params);
}

export const getMoreDeptList = (params) => {
	return WeaTools.callApi('/api/hrm/usedemandrp/getMoreDeptList', 'GET', params);
}

export const getMoreJobtitleList = (params) => {
	return WeaTools.callApi('/api/hrm/usedemandrp/getMoreJobtitleList', 'GET', params);
}

export const getSummaryDatas = (params) => {
	return WeaTools.callApi('/api/hrm/usedemandrp/getRpResult3', 'GET', params);
}

export const getDetailSearchList = (params) => {
	return WeaTools.callApi('/api/hrm/usedemandrp/getDetailSearchList', 'GET', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/useDemand.js